export default __webpack_public_path__ + "static/media/footer-logo.220daf1e.svg";